import { render, staticRenderFns } from "./SkillFields.vue?vue&type=template&id=2077bde2"
import script from "./SkillFields.vue?vue&type=script&lang=js"
export * from "./SkillFields.vue?vue&type=script&lang=js"
import style0 from "./SkillFields.vue?vue&type=style&index=0&id=2077bde2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports